import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CnesFinderService {
  private cns!: CNES;

  constructor(private httpClient: HttpClient) {}

  findCNS(cnsCode: string): CNES | null {
    this.httpClient
      .get(
        'https://apidadosabertos.saude.gov.br/cnes/estabelecimentos/' + cnsCode
      )
      .subscribe((response) => {
        this.cns = response;
        return this.cns;
      });
    return null;
  }
}

export class CNES {
  cnesCode?: number;
  numero_cnpj_entidade?: any;
  nome_razao_social?: string;
  nome_fantasia?: string;
  natureza_organizacao_entidade?: any;
  tipo_gestao?: string;
  descricao_nivel_hierarquia?: any;
  descricao_esfera_administrativa?: any;
  codigo_tipo_unidade?: string;
  codigo_cep_estabelecimento?: string;
  endereco_estabelecimento?: string;
  numero_estabelecimento?: string;
  bairro_estabelecimento?: string;
  numero_telefone_estabelecimento?: string;
  latitude_estabelecimento_decimo_grau?: number;
  longitude_estabelecimento_decimo_grau?: number;
  endereco_email_estabelecimento?: any;
  numero_cnpj?: any;
  codigo_identificador_turno_atendimento?: number;
  descricao_turno_atendimento?: string;
  estabelecimento_faz_atendimento_ambulatorial_sus?: string;
  codigo_estabelecimento_saude?: number;
  codigo_uf?: number;
  codigo_municipio?: number;
  descricao_natureza_juridica_estabelecimento?: number;
  codigo_motivo_desabilitacao_estabelecimento?: any;
  estabelecimento_possui_centro_cirurgico?: number;
  estabelecimento_possui_centro_obstetrico?: number;
  estabelecimento_possui_centro_neonatal?: number;
  estabelecimento_possui_atendimento_hospitalar?: number;
  estabelecimento_possui_servico_apoio?: 1;
  estabelecimento_possui_atendimento_ambulatorial?: number;
  codigo_atividade_ensino_unidade?: number;
  codigo_natureza_organizacao_unidade?: any;
  codigo_nivel_hierarquia_unidade?: any;
  codigo_esfera_administrativa_unidade?: any;
}



// {
//   "cnesCode": 2539187,
//   "numero_cnpj_entidade": null,
//   "nome_razao_social": "CARLOS LANE FOGACA",
//   "nome_fantasia": "CARLOS LANE FOGACA",
//   "natureza_organizacao_entidade": null,
//   "tipo_gestao": "M",
//   "descricao_nivel_hierarquia": null,
//   "descricao_esfera_administrativa": null,
//   "codigo_tipo_unidade": 22,
//   "codigo_cep_estabelecimento": "89801030",
//   "endereco_estabelecimento": "RUA BARAO DO RIO BRANCO",
//   "numero_estabelecimento": "300",
//   "bairro_estabelecimento": "CENTRO",
//   "numero_telefone_estabelecimento": "(49)3238210",
//   "latitude_estabelecimento_decimo_grau": -27.1018493,
//   "longitude_estabelecimento_decimo_grau": -52.6100444,
//   "endereco_email_estabelecimento": null,
//   "numero_cnpj": null,
//   "codigo_identificador_turno_atendimento": "03",
//   "descricao_turno_atendimento": "ATENDIMENTOS NOS TURNOS DA MANHA E A TARDE",
//   "estabelecimento_faz_atendimento_ambulatorial_sus": "NAO",
//   "codigo_estabelecimento_saude": "4204202539187",
//   "codigo_uf": 42,
//   "codigo_municipio": 420420,
//   "descricao_natureza_juridica_estabelecimento": "4000",
//   "codigo_motivo_desabilitacao_estabelecimento": null,
//   "estabelecimento_possui_centro_cirurgico": 0,
//   "estabelecimento_possui_centro_obstetrico": 0,
//   "estabelecimento_possui_centro_neonatal": 0,
//   "estabelecimento_possui_atendimento_hospitalar": 0,
//   "estabelecimento_possui_servico_apoio": 1,
//   "estabelecimento_possui_atendimento_ambulatorial": 0,
//   "codigo_atividade_ensino_unidade": "04",
//   "codigo_natureza_organizacao_unidade": null,
//   "codigo_nivel_hierarquia_unidade": null,
//   "codigo_esfera_administrativa_unidade": null
// },
// {
//   "cnesCode": 2237601,
//   "numero_cnpj_entidade": null,
//   "nome_razao_social": "HOSPITAL DE CLINICAS DE PORTO ALEGRE",
//   "nome_fantasia": "HOSPITAL DE CLINICAS",
//   "natureza_organizacao_entidade": null,
//   "tipo_gestao": "M",
//   "descricao_nivel_hierarquia": null,
//   "descricao_esfera_administrativa": null,
//   "codigo_tipo_unidade": 5,
//   "codigo_cep_estabelecimento": "90035903",
//   "endereco_estabelecimento": "RUA RAMIRO BARCELOS",
//   "numero_estabelecimento": "2350",
//   "bairro_estabelecimento": "SANTANA",
//   "numero_telefone_estabelecimento": "(51) 3359 8000",
//   "latitude_estabelecimento_decimo_grau": -30.0391768307903,
//   "longitude_estabelecimento_decimo_grau": -51.2079481884709,
//   "endereco_email_estabelecimento": "hcpa@hcpa.edu.br",
//   "numero_cnpj": "87020517000120",
//   "codigo_identificador_turno_atendimento": "06",
//   "descricao_turno_atendimento": "ATENDIMENTO CONTINUO DE 24 HORAS/DIA (PLANTAO:INCLUI SABADOS, DOMINGOS E FERIADOS)",
//   "estabelecimento_faz_atendimento_ambulatorial_sus": "SIM",
//   "codigo_estabelecimento_saude": "4314902237601",
//   "codigo_uf": 43,
//   "codigo_municipio": 431490,
//   "descricao_natureza_juridica_estabelecimento": "2011",
//   "codigo_motivo_desabilitacao_estabelecimento": null,
//   "estabelecimento_possui_centro_cirurgico": 1,
//   "estabelecimento_possui_centro_obstetrico": 1,
//   "estabelecimento_possui_centro_neonatal": 1,
//   "estabelecimento_possui_atendimento_hospitalar": 1,
//   "estabelecimento_possui_servico_apoio": 1,
//   "estabelecimento_possui_atendimento_ambulatorial": 1,
//   "codigo_atividade_ensino_unidade": "05",
//   "codigo_natureza_organizacao_unidade": null,
//   "codigo_nivel_hierarquia_unidade": null,
//   "codigo_esfera_administrativa_unidade": null
// }